import _classCallCheck from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { getRectForNode } from '../../utilities/geometry.js';
import { useStickyManager } from '../../utilities/sticky-manager/hooks.js';

var StickyInner =
/*#__PURE__*/
function (_Component) {
  _inherits(StickyInner, _Component);

  function StickyInner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StickyInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StickyInner)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isSticky: false,
      style: {}
    };
    _this.placeHolderNode = null;
    _this.stickyNode = null;

    _this.setPlaceHolderNode = function (node) {
      _this.placeHolderNode = node;
    };

    _this.setStickyNode = function (node) {
      _this.stickyNode = node;
    };

    _this.handlePositioning = function (stick) {
      var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var left = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var isSticky = _this.state.isSticky;

      if (stick && !isSticky || !stick && isSticky) {
        _this.adjustPlaceHolderNode(stick);

        _this.setState({
          isSticky: !isSticky
        });
      }

      var style = stick ? {
        position: 'fixed',
        top: top,
        left: left,
        width: width
      } : {};

      _this.setState({
        style: style
      });
    };

    _this.adjustPlaceHolderNode = function (add) {
      if (_this.placeHolderNode && _this.stickyNode) {
        _this.placeHolderNode.style.paddingBottom = add ? "".concat(getRectForNode(_this.stickyNode).height, "px") : '0px';
      }
    };

    return _this;
  }

  _createClass(StickyInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          boundingElement = _this$props.boundingElement,
          _this$props$offset = _this$props.offset,
          offset = _this$props$offset === void 0 ? false : _this$props$offset,
          _this$props$disableWh = _this$props.disableWhenStacked,
          disableWhenStacked = _this$props$disableWh === void 0 ? false : _this$props$disableWh,
          stickyManager = _this$props.stickyManager;
      if (!this.stickyNode || !this.placeHolderNode) return;
      stickyManager.registerStickyItem({
        stickyNode: this.stickyNode,
        placeHolderNode: this.placeHolderNode,
        handlePositioning: this.handlePositioning,
        offset: offset,
        boundingElement: boundingElement,
        disableWhenStacked: disableWhenStacked
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var stickyManager = this.props.stickyManager;
      if (!this.stickyNode) return;
      stickyManager.unregisterStickyItem(this.stickyNode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          style = _this$state.style,
          isSticky = _this$state.isSticky;
      var children = this.props.children;
      var childrenContent = isFunction(children) ? children(isSticky) : children;
      return (
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.setPlaceHolderNode
        }),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.setStickyNode,
          style: style
        }, childrenContent))
      );
    }
  }]);

  return StickyInner;
}(Component); // This should have a typeguard instead of using Function
// eslint-disable-next-line @typescript-eslint/ban-types


function isFunction(arg) {
  return typeof arg === 'function';
}

function Sticky(props) {
  var stickyManager = useStickyManager();
  return (
    /*#__PURE__*/
    React.createElement(StickyInner, Object.assign({}, props, {
      stickyManager: stickyManager
    }))
  );
}

export { Sticky };